import React, {Component} from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import Textarea from 'react-validation/build/textarea'
import {isEmail, isEmpty, isMobilePhone} from 'validator';
import './contact-form.scss';
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";
import Modal from "react-responsive-modal";
import {handleNewMessage} from "../../../services/api";

let formInstanceCount = 0;

class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            phone: '',
            email: '',
            content: '',
            openBox: false,
            sending: false,
            failed: false,
        }
        // The form is rendered in several places at once (footer, modal), so ids must be unique.
        this.idPrefix = `cpr-contact-${++formInstanceCount}`;
    }

    required = (value) => {
        if (isEmpty(value)) {
            return <small className="cpr-field__error" role="alert">{this.props.translate('field_required')}</small>;
        }
    }

    email = (value) => {
        if (!isEmail(value)) {
            return <small className="cpr-field__error" role="alert">{this.props.translate('invalid_email')}</small>;
        }
    };

    phone = (value) => {
        if (!isMobilePhone(value)) {
            return <small className="cpr-field__error" role="alert">{this.props.translate('invalid_phone')}</small>;
        }
    }

    onSubmit = (e) => {
        const {onClose} = this.props;
        e.preventDefault();
        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            onClose();
            const message = {
                id: null,
                clientName: this.state.name,
                phoneNumber: this.state.phone,
                email: this.state.email,
                text: this.state.content,
            };
            this.setState({sending: true, failed: false});
            handleNewMessage(message)
                .then(() => {
                    this.setState({openBox: true, sending: false});
                })
                .catch(() => {
                    this.setState({openBox: true, sending: false, failed: true});
                });
        }
    };

    onCloseModal = () => {
        this.setState({openBox: false});
    };

    render() {
        const {translate} = this.props;
        const id = (name) => `${this.idPrefix}-${name}`;
        return (
            <div className="cpr-contact-form">
                <Form className="form-group-v1" onSubmit={e => this.onSubmit(e)} ref={c => {
                    this.form = c
                }} noValidate>
                    <div className="cpr-contact-form__row">
                        <div className="cpr-field">
                            <label className="cpr-field__label" htmlFor={id('name')}>{translate('your_name_label')}</label>
                            <Input id={id('name')} name="name" autoComplete="name" onChange={(e) => {
                                this.setState({name: e.target.value})
                            }} value={this.state.name} type="text"
                                   className="cpr-field__input" validations={[this.required]}/>
                        </div>
                        <div className="cpr-field">
                            <label className="cpr-field__label" htmlFor={id('phone')}>{translate('phone_label')}</label>
                            <Input id={id('phone')} name="phone" autoComplete="tel" inputMode="tel" onChange={(e) => {
                                this.setState({phone: e.target.value})
                            }} value={this.state.phone} type="tel"
                                   className="cpr-field__input" validations={[this.required, this.phone]}/>
                        </div>
                    </div>

                    <div className="cpr-field">
                        <label className="cpr-field__label" htmlFor={id('email')}>{translate('email_label')}</label>
                        <Input id={id('email')} name="email" autoComplete="email" onChange={(e) => {
                            this.setState({email: e.target.value})
                        }} value={this.state.email} type="email"
                               className="cpr-field__input" validations={[this.required, this.email]}/>
                    </div>

                    <div className="cpr-field">
                        <label className="cpr-field__label" htmlFor={id('content')}>{translate('message_label')}</label>
                        <Textarea id={id('content')} name="content" onChange={(e) => {
                            this.setState({content: e.target.value})
                        }} value={this.state.content} className="cpr-field__input"
                                  placeholder={translate('how_can_we_help_you')} rows="3"
                                  validations={[this.required]}/>
                    </div>
                    <button type="submit" className="cpr-btn cpr-btn--primary cpr-btn--block"
                            disabled={this.state.sending}>
                        {this.state.sending ? translate('sending') : translate('submit')}
                    </button>
                    <CheckButton style={{display: 'none'}} ref={c => {
                        this.checkBtn = c
                    }}/>
                </Form>
                <Modal open={this.state.openBox} onClose={this.onCloseModal} center
                       classNames={{modal: 'cpr-modal', overlay: 'cpr-modal-overlay'}}>
                    <div className="cpr-modal__body" role="status">
                        {this.state.failed ? (
                            <p className="cpr-lead">{translate('send_failed')}</p>
                        ) : (
                            <>
                                <h3 className="cpr-h3">{translate('success_done')}</h3>
                                <p className="cpr-lead">{translate('soon_reply')}</p>
                            </>
                        )}
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(ContactForm));
